import { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import LoadingContainer from 'components/common/LoadingContainer';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDonor } from 'hooks/useDonors';

export const DonorContext = createContext({
  donor: null
});

export function DonorContextProvider({ children }) {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const donorId = searchParams.get('donorId');

  const { donor, isLoading: donorLoading } = useDonor(donorId || id);

  const contextValue = useMemo(() => ({
    donor: donor ?? {}
  }), [donor]);

  return (
    <DonorContext.Provider value={contextValue}>
      {donorLoading ? <LoadingContainer /> : children}
    </DonorContext.Provider>
  );
}

DonorContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useDonorContext = () => {
  const context = useContext(DonorContext);
  if (context === undefined) {
    throw new Error(
      'useDonorContext must be used within a DonorContextProvider'
    );
  }
  return context;
};

export default DonorContext;
